export const isPreviewMode = (): boolean =>
  (globalThis as typeof globalThis & { __IS_PREVIEW_MODE__: boolean }).__IS_PREVIEW_MODE__ ||
  globalThis.location.search.includes('preview=true');
